<app-topheader></app-topheader>
<div class="scrollingcontainer ">
    <!-- <app-ship-banner></app-ship-banner> -->
    <div class="container">

        <app-ship-name></app-ship-name>
        <div class="tenpxtop"></div>
        <app-goldbar></app-goldbar>
        <app-deck-plans singledeck="{{sdplDeck}}" imagetype="map"></app-deck-plans>

    </div>
</div>
<app-bottommenu></app-bottommenu>